module.exports = __webpack_public_path__ + "d335976144bb1acb3504b21258c10ddf.png";